import { ActivityIndicator, View } from "react-native";
import { BaseText, Title } from "~/components/layout/text";
import { Gap, Items, Padding, Width } from "~/constants/layout";

export const Loading = () => {
    return (
        <View style={[Items.center, Width.full, Gap.sm, Padding.horizontal_lg, Padding.vertical_12]}>
            <ActivityIndicator size="large" />
            <Title size="xl" align="center">
                Loading
            </Title>
            <BaseText align="center">This will just take a moment.</BaseText>
        </View>
    );
};
